/** @format */

import { useEffect, useState } from "react";
import POSItems from "./POSItems";
import "./pos.css";
import { POSCart } from "./Cart";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../Layout/Loader";
import { openView } from "../../ReduxToolkit/Reducers/viewReducer";

export const POSHome = () => {
  const { status, isPaying, register_id } = useSelector((state) => state.cart);
  const { products, isLoading } = useSelector((state) => state.products);
  const [showRegisterModal, setShowRegisterModal] = useState(true);
  const [searchInputRef, setSearchInputRef] = useState(null);
  const dispatch = useDispatch();

  // Load POS items from localStorage (set during login from global_settings)
  // useEffect(() => {
  //   const savedItems = JSON.parse(user_data?.global_settings?.pos_items);

  //   if (
  //     savedItems
  //   ) {
  //     try {
  //               if (Array.isArray(savedItems)) {
  //         const validItems = savedItems.filter(
  //           (item) => item && products.some((p) => p.id === item.id)
  //         );
  //         dispatch(setPosItems(validItems));
  //       } else {
  //         dispatch(setPosItems([]));
  //       }
  //     } catch (error) {
  //       console.error("Failed to parse POS items:", error);
  //       localStorage.removeItem("pos_items");
  //       dispatch(setPosItems([]));
  //     }
  //   } else {
  //     dispatch(setPosItems([]));
  //   }
  // }, [products, dispatch]);

  // Trigger openView only when isPaying becomes true
  useEffect(() => {
    if (isPaying) {
      dispatch(openView("pay_cart"));
    }
  }, [isPaying, dispatch]);

  const toggleRegisterModal = () => {
    setShowRegisterModal(!showRegisterModal);
  };

  // Global Enter key handler to focus search input
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      if (e.key === "Enter" && !showRegisterModal) {
        const activeElement = document.activeElement;
        const isInputFocused =
          activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.tagName === "SELECT";
        const isButtonFocused = activeElement.tagName === "BUTTON";
        const isModalOpen =
          document.querySelector(".modal.show") ||
          document.querySelector(".modal.fade.show");

        if (
          !isInputFocused &&
          !isButtonFocused &&
          !isModalOpen &&
          searchInputRef
        ) {
          e.preventDefault();
          searchInputRef.focus();
        }
      }
    };

    document.addEventListener("keydown", handleGlobalKeyDown);
    return () => document.removeEventListener("keydown", handleGlobalKeyDown);
  }, [showRegisterModal, searchInputRef]);

  return (
    <div className="page-body pos-container">
      {isLoading && <Loader />}
      {status && <Loader />}

      <div className="product-area" style={{ backgroundColor: "#000" }}>
        <POSItems onSearchInputRef={setSearchInputRef} />
      </div>

      <div className="cart-area">
        {register_id ? (
          <POSCart />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="text-center">
              <h4>No Active Register</h4>
              <p>Please wait while a register is being opened automatically.</p>
            </div>
          </div>
        )}
      </div>
      {/* 
      <RegistersModal isOpen={showRegisterModal} toggle={toggleRegisterModal} /> */}
    </div>
  );
};

export default POSHome;
